$(function() {
    "use strict";

    var $actions = $('.text-edit__actions');

    if (!$actions.length) {
        return;
    }

    var $textarea = $actions.find('.article-textarea');

    var $insertQuoteModal = $('.text-edit__modal_article-quote');
    var $insertQuoteButton = $insertQuoteModal.find('.text-edit__modal_article-quote__insert');
    var $insertQuoteImageInput = $insertQuoteModal.find('.image-crop-link__change');
    var $insertQuotePhotoIdInput = $insertQuoteModal.find('[name="quote__photo-id"]');

    $insertQuoteImageInput.on('CropImage::Uploaded', function(event, data) {
        $insertQuotePhotoIdInput.val(data.photo_id);
    });

    $insertQuoteButton.on('click', function() {
        var photo_id = $insertQuotePhotoIdInput.val();
        var name = $insertQuoteModal.find('[name="quote__name"]').val();
        var desc = $insertQuoteModal.find('[name="quote__desc"]').val();
        var company = $insertQuoteModal.find('[name="quote__company"]').val();
        var link = $insertQuoteModal.find('[name="quote__link"]').val();
        var text = $insertQuoteModal.find('[name="quote__text"]').val();
        insertText('\n[article_quote]\n' +
                   (photo_id ? '[article_quote_photo_id]' + photo_id + '[/article_quote_photo_id]\n' : '') +
                   (name ? '[article_quote_name]' + name + '[/article_quote_name]\n' : '') +
                   (desc ? '[article_quote_desc]' + desc + '[/article_quote_desc]\n' : '') +
                   (company ? '[article_quote_company]' + company + '[/article_quote_company]\n' : '') +
                   (link ? '[article_quote_link]' + link + '[/article_quote_link]\n' : '') +
                   (text ? '[article_quote_text]' + text + '[/article_quote_text]\n' : '') +
                   '[/article_quote]\n',
                   '', $textarea.get(0));
        $insertQuoteModal.find('input, textarea').val('');

        Modal.closeModal($insertQuoteModal.attr('id'));
    });

    var $insertMarketModal = $('.text-edit__modal_market');
    var $insertMarketButton = $insertMarketModal.find('.text-edit__modal_market__insert');

    $insertMarketButton.on('click', function() {
        var $inputs = $insertMarketModal.find('[name="market-item\[\]"]');
        var title = $insertMarketModal.find('[name="market__title"]').val();
        var slug = $insertMarketModal.find('[name="market__slug"]').val();
        insertText('\n[market_items]', '', $textarea.get(0));
        $inputs.each(function(){
            if (!$(this).val()) {
                return;
            }
            insertText('[market_item]' + $(this).val() + '[/market_item]', '', $textarea.get(0));
        });
        insertText('\n[market_items_title]' + title + '[/market_items_title]\n', '', $textarea.get(0));
        insertText('\n[market_items_slug]' + slug + '[/market_items_slug]\n', '', $textarea.get(0));
        insertText('[/market_items]\n', '', $textarea.get(0));

        $insertMarketModal.find('input, textarea').val('');

        Modal.closeModal($insertMarketModal.attr('id'));
    });

    var $insertGalleryModal = $('.text-edit__modal_gallery');
    var $insertGalleryButton = $insertGalleryModal.find('.text-edit__modal_gallery__insert');

    $insertGalleryButton.on('click', function() {
        var $inputs = $insertGalleryModal.find('[name="photo_gallery_photo_id\[\]"]');
        var slug = $insertGalleryModal.find('[name="photo_gallery_slug"]').val();

        insertText('\n[photo_gallery]\n', '', $textarea.get(0));
        $inputs.each(function(){
            if (!$(this).val()) {
                return;
            }
            insertText('[photo_gallery_photo_id]' + $(this).val() + '[/photo_gallery_photo_id]', '', $textarea.get(0));
        });
        insertText('\n[photo_gallery_slug]' + slug + '[/photo_gallery_slug]\n', '', $textarea.get(0));
        insertText('[/photo_gallery]\n', '', $textarea.get(0));

        $insertGalleryModal.find('input, textarea').val('');

        Modal.closeModal($insertGalleryModal.attr('id'));
    });

    var $insertPhotoModal = $('.text-edit__modal_photo-with-caption');
    var $insertPhotoButton = $insertPhotoModal.find('.text-edit__modal_photo-with-caption__insert');
    var $insertPhotoPhotoIdInput = $insertPhotoModal.find('[name="photo_id"]');
    var $insertPhotoPreview = $insertPhotoModal.find('.text-edit__modal_photo__preview__image');

    $insertPhotoButton.on('click', function() {
        var photo_id = $insertPhotoPhotoIdInput.val();
        var caption = $insertPhotoModal.find('[name="photo__caption"]').val();
        var link = $insertPhotoModal.find('[name="photo__caption-link"]').val();

        insertText('\n[photo_with_caption]\n' +
                   (photo_id ? '[photo_with_caption_id]' + photo_id + '[/photo_with_caption_id]\n' : '') +
                   (caption ? '[photo_with_caption_caption]' + caption + '[/photo_with_caption_caption]\n' : '') +
                   (link ? '[photo_with_caption_link]' + link + '[/photo_with_caption_link]\n' : '') +
                   '[/photo_with_caption]\n',
                   '', $textarea.get(0));

        $insertPhotoModal.find('input, textarea').val('');
        $insertPhotoPreview.attr('src', '');

        Modal.closeModal($insertPhotoModal.attr('id'));
    });

    var $insertVideoModal = $('.text-edit__modal_video-with-caption');
    var $insertVideoButton = $insertVideoModal.find('.text-edit__modal_video-with-caption__insert');
    var $insertVideoForm = $insertVideoModal.find('.text-edit__insert-video-form');

    $insertVideoButton.on('click', function() {

        $.ajax({
            url: $insertVideoForm.attr('action'),
            type: 'POST',
            data: new FormData($insertVideoForm.get(0)),
            processData: false,
            contentType: false,
            dataType: 'json'
        })
            .done(function(data) {
                debugger;
                if (!data.err) {
                    var video_id = data.id;
                    var caption = $insertVideoModal.find('[name="video__caption"]').val();
                    var link = $insertVideoModal.find('[name="video__caption-link"]').val();

                    insertText('\n[video_with_caption]\n' +
                        (video_id ? '[video_with_caption_id]' + video_id + '[/video_with_caption_id]\n' : '') +
                        (caption ? '[video_with_caption_caption]' + caption + '[/video_with_caption_caption]\n' : '') +
                        (link ? '[video_with_caption_link]' + link + '[/video_with_caption_link]\n' : '') +
                        '[/video_with_caption]\n',
                        '', $textarea.get(0));

                    $insertVideoModal.find('input, textarea').val('');

                    Modal.closeModal($insertVideoModal.attr('id'));
                }
            });
    });

    $(document).on('ready', function () {
        $(document).trigger('PhotoUploadOverlay::registerCallback', [
            {
                name:             'article-attach-photo',
                callbackFunction: function ($caller, photos, ideabook, size, isLast) {

                    $(document).trigger('PhotoUploadOverlay::hide');

                    if (!photos.length) {
                        return;
                    }

                    var photo = photos[0];
                    $insertPhotoPhotoIdInput.val(photo.id);
                    $insertPhotoPreview.attr('src', photo.thumbnailSrc);
                }
            }
        ]);
    });
});